"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDetailsScreenBase = void 0;
var react_1 = __importStar(require("react"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var WorkflowCard_1 = require("../../components/WorkflowCard");
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
/**
 * Component renders a screen with account details information for support with the application.
 * Contact information is pulled from the context passed into the workflow.
 *
 * @param firstNameLabel label for the first name text field
 * @param initialFirstName initial value for the first name text field
 * @param firstNameValidator function that validates the first name text field
 * @param firstNameTextFieldProps props to pass to the first name field
 * @param lastNameLabel label for the last name text field
 * @param initialLastName initial value for the last name text field
 * @param lastNameValidator function that validates the last name text field
 * @param lastNameTextFieldProps props to pass to the last name field
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 *
 * @category Component
 */
var AccountDetailsScreenBase = function (props) {
    var firstNameLabel = props.firstNameLabel, initialFirstName = props.initialFirstName, _a = props.firstNameValidator, firstNameValidator = _a === void 0 ? function () { } : _a, firstNameTextFieldProps = props.firstNameTextFieldProps, lastNameLabel = props.lastNameLabel, initialLastName = props.initialLastName, _b = props.lastNameValidator, lastNameValidator = _b === void 0 ? function () { } : _b, lastNameTextFieldProps = props.lastNameTextFieldProps, errorDisplayConfig = props.errorDisplayConfig;
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    var firstNameRef = (0, react_1.useRef)(null);
    var lastNameRef = (0, react_1.useRef)(null);
    var _c = react_1.default.useState(initialFirstName ? initialFirstName : ''), firstNameInput = _c[0], setFirstNameInput = _c[1];
    var _d = react_1.default.useState(initialLastName ? initialLastName : ''), lastNameInput = _d[0], setLastNameInput = _d[1];
    var _e = react_1.default.useState(false), isFirstNameValid = _e[0], setIsFirstNameValid = _e[1];
    var _f = react_1.default.useState(false), isLastNameValid = _f[0], setIsLastNameValid = _f[1];
    var _g = react_1.default.useState(''), firstNameError = _g[0], setFirstNameError = _g[1];
    var _h = react_1.default.useState(''), lastNameError = _h[0], setLastNameError = _h[1];
    var _j = react_1.default.useState(false), shouldValidateFirstName = _j[0], setShouldValidateFirstName = _j[1];
    var _k = react_1.default.useState(false), shouldValidateLastName = _k[0], setShouldValidateLastName = _k[1];
    var handleFirstNameInputChange = (0, react_1.useCallback)(function (firstName) {
        setFirstNameInput(firstName);
        var firstNameValidatorResponse = firstNameValidator(firstName);
        setIsFirstNameValid(typeof firstNameValidatorResponse === 'boolean' ? firstNameValidatorResponse : false);
        setFirstNameError(typeof firstNameValidatorResponse === 'string' ? firstNameValidatorResponse : '');
    }, [firstNameValidator]);
    var handleLastNameInputChange = (0, react_1.useCallback)(function (lastName) {
        setLastNameInput(lastName);
        var lastNameValidatorResponse = lastNameValidator(lastName);
        setIsLastNameValid(typeof lastNameValidatorResponse === 'boolean' ? lastNameValidatorResponse : false);
        setLastNameError(typeof lastNameValidatorResponse === 'string' ? lastNameValidatorResponse : '');
    }, [lastNameValidator]);
    (0, react_1.useEffect)(function () {
        if (firstNameInput.length > 0) {
            setShouldValidateFirstName(true);
            handleFirstNameInputChange(firstNameInput);
        }
        if (lastNameInput.length > 0) {
            setShouldValidateLastName(true);
            handleLastNameInputChange(lastNameInput);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(WorkflowCard_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardHeader, __assign({}, headerProps)),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardInstructions, __assign({}, instructionsProps)),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardBody, null,
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(TextField_1.default, __assign({ id: "first", fullWidth: true, variant: "filled", inputRef: firstNameRef, label: firstNameLabel, value: firstNameInput, error: shouldValidateFirstName && !isFirstNameValid, helperText: shouldValidateFirstName && firstNameError, sx: {
                        mb: { md: 0, sm: 1, xs: 4 },
                    } }, firstNameTextFieldProps, { onChange: function (e) {
                        // eslint-disable-next-line no-unused-expressions
                        (firstNameTextFieldProps === null || firstNameTextFieldProps === void 0 ? void 0 : firstNameTextFieldProps.onChange) && firstNameTextFieldProps.onChange(e);
                        handleFirstNameInputChange(e.target.value);
                    }, onKeyUp: function (e) {
                        if (e.key === 'Enter' && lastNameRef.current)
                            lastNameRef.current.focus();
                    }, onBlur: function () { return setShouldValidateFirstName(true); } })),
                react_1.default.createElement(TextField_1.default, __assign({ id: "last", fullWidth: true, variant: "filled", sx: {
                        mt: { md: 4, sm: 3 },
                    }, inputRef: lastNameRef, label: lastNameLabel, value: lastNameInput, error: shouldValidateLastName && !isLastNameValid, helperText: shouldValidateLastName && lastNameError }, lastNameTextFieldProps, { onChange: function (e) {
                        // eslint-disable-next-line no-unused-expressions
                        (lastNameTextFieldProps === null || lastNameTextFieldProps === void 0 ? void 0 : lastNameTextFieldProps.onChange) && lastNameTextFieldProps.onChange(e);
                        handleLastNameInputChange(e.target.value);
                    }, onKeyUp: function (e) {
                        var _a;
                        if (e.key === 'Enter' && isFirstNameValid && isLastNameValid && actionsProps.canGoNext)
                            (_a = actionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(actionsProps);
                    }, onBlur: function () { return setShouldValidateLastName(true); } })))),
        react_1.default.createElement(WorkflowCard_1.WorkflowCardActions, __assign({}, actionsProps, { canGoNext: actionsProps.canGoNext && isFirstNameValid && isLastNameValid }))));
};
exports.AccountDetailsScreenBase = AccountDetailsScreenBase;
